import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  base_uri;
  constructor(
    private authService: AuthenticationService,
    private http: HttpClient
  ) { 
    this.base_uri = environment.notification_url;
  }

  generateOtp(data) {
    let url = this.base_uri + "otp/generate";
    return this.http.post(url, data, {});
  }

  verifyOtp(data) {
    let url = this.base_uri + "otp/verify";
    return this.http.post(url, data, {});
  }

  getConsentForm(id:any, token:any) {
    let url = this.base_uri + "form/get_visit_form?id=" + id + "&token=" + token;
    return this.http.get(url, {});
  }

  updateConsentForm(data){
    let url = this.base_uri + "form/update_visit_form";
    return this.http.put(url, data, {});
  }
}
